import(/* webpackMode: "eager" */ "C:\\Websites\\pawtree-FE\\PawtreeFrontend\\src\\app\\global-error.tsx");
